import { DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { AuthContainerComponent } from '@app/core/containers/auth-container/auth-container.component';
import { ContentContainerComponent } from '@app/core/containers/content-container/content-container.component';
import { ErrorContainerComponent } from '@app/core/containers/error-container/error-container.component';
import { DivisionWidgetsModule } from '@app/features/division/division-widgets.module';
import { FilterWidgetsModule } from '@app/features/filter/filter-widgets.module';
import { FilterComponent } from '@app/features/filter/widgets/filter/filter.component';
import { NotificationModule } from '@app/features/notification/notification.module';
import { UserWidgetsModule } from '@app/features/user/user-widgets.module';
import { SharedModule } from '@app/shared/shared.module';
import { ButtonIconHeaderComponent } from './components/main-header/button-icon-header/button-icon-header.component';
import { HeaderToolbarComponent } from './components/main-header/header-toolbar/header-toolbar.component';
import { MainHeaderComponent } from './components/main-header/main-header.component';
import { TitleBarComponent } from './components/main-header/title-bar/title-bar.component';
import { MainMenuComponent } from './components/main-menu/main-menu.component';
import { MenuEntryComponent } from './components/main-menu/menu-entry/menu-entry.component';
import { throwIfAlreadyLoaded } from './guards/module-import.guard';

@NgModule({
  declarations: [
    AuthContainerComponent,
    ContentContainerComponent,
    MainHeaderComponent,
    TitleBarComponent,
    ErrorContainerComponent,
    HeaderToolbarComponent,
    MainMenuComponent,
    MenuEntryComponent,
    ButtonIconHeaderComponent
  ],
  imports: [
    HttpClientModule,
    SharedModule,
    UserWidgetsModule.forChild(),
    DivisionWidgetsModule,
    FilterWidgetsModule,
    NotificationModule
  ],
  exports: [AuthContainerComponent, ContentContainerComponent, ErrorContainerComponent],
  providers: [
    DatePipe,
    {
      provide: 'DialogWidth',
      useValue: 350
    }
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
